import { isString } from 'lodash';
import React, {
  ChangeEvent,
  startTransition,
  useEffect,
  useState,
} from 'react';
import { InputTextLabel } from 'src/components/input/Input.styled';

import { WidgetsCommonProps } from '../widget.interface';
import { InputWrapper, ValidationTextField } from './InputWidget.styled';

export const InputWidget = React.forwardRef(
  (props: WidgetsCommonProps, ref) => {
    const { value = '', error, hasError, label, disabled, onChange } = props;
    const [inputValue, setInputValue] = useState<string>(value ?? '');
    // Update value from parent when value is passed
    useEffect(() => {
      setInputValue(value);
    }, [value]);

    const handleChange = ({
      target: { value },
    }: ChangeEvent<HTMLInputElement>) => {
      setInputValue(value);
      props.options?.useImmediateUpdate
        ? onChange(value)
        : startTransition(() => {
            onChange(value);
          });
    };

    return (
      <InputWrapper>
        {isString(label) ? <InputTextLabel>{label}</InputTextLabel> : label}
        <ValidationTextField
          data-testid={label}
          value={inputValue}
          onChange={handleChange}
          error={hasError}
          helperText={hasError ? error : undefined}
          disabled={disabled}
          multiline={props.multiline}
          rows={props.rows}
          inputRef={ref}
        />
      </InputWrapper>
    );
  },
);
